<template>
  <div>
    <header>
      <nav class="navbar teal lighten-1" :class="{'warning-background': viewConfig.shouldUseNavbarWarningBackground}" role="navigation">
        <div class="nav-wrapper">
          <a v-link="{path: '/'}" class="brand-logo waves-effect waves-light center">Identity Platform</a>
        </div>
      </nav>
    </header>
    <div class="headerimg" :class="{'dev-background': viewConfig.shouldUseNavbarWarningBackground}">
    </div>
    <main class="container" id="main" v-cloak>
      <div class="row">
        <div class="col s12 m10 offset-m1 l8 offset-l2">
          <div class="card white">
            <div class="card-content">
              <div v-if="loginPicture">
                <div class="input-field col s12 offset-m1 m10 offset-l3 l6 center-align">
                   <img :src="loginPicture" alt="" style="width:267px;height:89px;margin-top:20px;margin-bottom:20px;"/>
                </div>
              </div>
              <router-view></router-view>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import db from '../../db'

export default {
  data() {
    return {
      viewConfig: {
        shouldUseNavbarWarningBackground: false,
        skin: '',
        couchDbEnabled: false
      },
      loginPicture: null
    }
  },
  created() {
    this.viewConfig = db.get('viewConfig')
    if (this.viewConfig.skin) {
      this.loginPicture = `assets/skins/${this.viewConfig.skin}/big-logo.jpg`
    }
  }
}
</script>

<style>
nav .nav-wrapper .brand-logo {
  padding: 0 10px;
  margin: 0 10px;
}

nav.navbar.warning-background {
  background-color: #a62632 !important;
}

[v-cloak] {
  display: none;
}
</style>



// WEBPACK FOOTER //
// Layout.vue?398d9947